<template>
  <card-container-layout>
    <default-card-title-component text="ENQUIRY"></default-card-title-component>
    <div class="mb-3">
      <card-info-text
        text="Total number of enquiries via the available channels"
      ></card-info-text>
    </div>
    <div class="report__enquiry-card-metrics-container">
      <template v-for="(render, index) in renderItems">
        <component
          :is="render.component"
          v-bind="render.props"
          :key="render.id"
        />
        <vertical-separator
          height="75px"
          gap="28px"
          :key="render.component"
          v-if="index + 1 < renderItems.length"
        ></vertical-separator>
      </template>
    </div>
  </card-container-layout>
</template>
<script>
import DefaultCardTitleComponent from '../Common/DefaultCardTitleComponent.vue';
import CardInfoText from '../Common/CardInfoText.vue';
import CardContainerLayout from '../Common/CardContainerLayout.vue';
import VerticalSeparator from '../Common/VerticalSeparator.vue';
import EnquiryViaEmailStatItem from '../StatItems/EnquiryViaEmailStatItem.vue';
import EnquiryViaPhoneStatItem from '../StatItems/EnquiryViaPhoneStatItem.vue';
import EnquiryViaFormStatItem from '../StatItems/EnquiryViaFormStatItem.vue';
import EnquiryViaSocialStatItem from '../StatItems/EnquiryViaSocialStatItem.vue';

export default {
  props: {
    emailMetric: [String, Number],
    phoneMetric: [String, Number],
    formMetric: [String, Number],
    socialMetric: [String, Number],
  },
  computed: {
    renderItems() {
      const renders = [];

      if (this.emailMetric !== 0 && this.emailMetric !== '0') {
        renders.push({
          id: 'emailMetric',
          component: EnquiryViaEmailStatItem,
          props: {
            metric: this.emailMetric,
          },
        });
      }

      if (this.phoneMetric !== 0 && this.phoneMetric !== '0') {
        renders.push({
          id: 'phoneMetric',
          component: EnquiryViaPhoneStatItem,
          props: {
            metric: this.phoneMetric,
          },
        });
      }

      if (this.formMetric !== 0 && this.formMetric !== '0') {
        renders.push({
          id: 'formMetric',
          component: EnquiryViaFormStatItem,
          props: {
            metric: this.formMetric,
          },
        });
      }

      if (this.socialMetric !== 0 && this.socialMetric !== '0') {
        renders.push({
          id: 'socialMetric',
          component: EnquiryViaSocialStatItem,
          props: {
            metric: this.socialMetric,
          },
        });
      }

      return renders;
    },
  },
  components: {
    DefaultCardTitleComponent,
    CardInfoText,
    CardContainerLayout,
    VerticalSeparator,
    EnquiryViaEmailStatItem,
    EnquiryViaPhoneStatItem,
    EnquiryViaFormStatItem,
    EnquiryViaSocialStatItem
  },
};
</script>

<style scoped>
.report__enquiry-card-metrics-container {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr auto 1fr;
}
</style>
